import React, { useState } from 'react';
import Calendar from './Calendar';
import { Button, ButtonGroup, Stack } from '@mui/material';
import { getReportUrl } from '../../../constants/apiUrl';
import { useSystemId } from '../../../hooks/useReduxSelectors';
import { useDispatch } from "react-redux";
import { fetchReports } from "../../../ducks/reportsDuck";
import { useTranslation } from "react-i18next";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { PictureAsPdf as PdfIcon } from "@mui/icons-material";


function ReportSearchBar({ reportName, energyReportType, openPrintDialog }) {

  const systemId = useSystemId();
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const [reportCount, setReportCount] = useState(3);

  const handlereportCountChange = (operator) => {
    let newCount = reportCount;
    if ((operator === "+") & (newCount < 10)) {
      newCount = newCount + 1;
    } else if (newCount > 1) {
      newCount = newCount - 1;
    }
    setReportCount(newCount);
  };

  const fetchReportsWithCount = () => {
    let args = {
      ReportName: reportName,
      Count: reportCount
    };
    if (reportName === "EnergiesReport") {
      let energyReportNameForFetch;
      if (energyReportType === "Month") {
        energyReportNameForFetch = "MonthHeatMap";
      } else {  // "Day"
        energyReportNameForFetch = "DayHeatMap";
      }
      args = {
        ReportName: energyReportNameForFetch,
        Count: reportCount,
      };
    }
    dispatch(fetchReports({ systemId, url: getReportUrl, type: reportName, args }));
  };

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={1} alignItems="center" sx={{ pb: 1, px: 1.5 }}>
      {/* Show latest N */}
      <ButtonGroup size="small" variant="outlined" sx={{ "& .MuiButton-root": { borderColor: "divider" } }}>
        <Button
          disabled={reportCount <= 1}
          onClick={() => handlereportCountChange("-")}
          sx={{ minWidth: 36 }}
        >
          <RemoveIcon fontSize="small" />
        </Button>
        <Button onClick={fetchReportsWithCount} sx={{ textTransform: "none", px: 2 }}>
          {t("Show latest")} {reportCount}
        </Button>
        <Button
          disabled={reportCount >= 10}
          onClick={() => handlereportCountChange("+")}
          sx={{ minWidth: 36 }}
        >
          <AddIcon fontSize="small" />
        </Button>
      </ButtonGroup>

      {/* Date range picker */}
      <Calendar reportName={reportName} energyReportType={energyReportType} />
      <Button
        variant="outlined"
        size="small"
        startIcon={<PdfIcon />}
        onClick={openPrintDialog}
      >
        {t("PDF")}
      </Button>
    </Stack>
  );
}

export default ReportSearchBar;